module.exports = __webpack_public_path__ + "static/media/open-treasure-chest-gold.ffeb441a.svg";